var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrop18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 12h-2V5c0-.6-.4-1-1-1H6V2c0-.6-.4-1-1-1s-1 .4-1 1v2H2c-.6 0-1 .4-1 1s.4 1 1 1h2v7c0 .6.4 1 1 1h7v2c0 .6.4 1 1 1s1-.4 1-1v-2h2c.6 0 1-.4 1-1s-.4-1-1-1zM6 12V6h6v6H6z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE2IDEyaC0yVjVjMC0uNi0uNC0xLTEtMUg2VjJjMC0uNi0uNC0xLTEtMXMtMSAuNC0xIDF2MkgyYy0uNiAwLTEgLjQtMSAxcy40IDEgMSAxaDJ2N2MwIC42LjQgMSAxIDFoN3YyYzAgLjYuNCAxIDEgMXMxLS40IDEtMXYtMmgyYy42IDAgMS0uNCAxLTFzLS40LTEtMS0xek02IDEyVjZoNnY2SDZ6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export { SvgCrop18 as ReactComponent };